module.exports = __webpack_public_path__ + "img/sentence@2x.40c700ee.png";